import { CircularProgress } from '@mui/material';
import Styles from './LoadingPage.module.scss';

export interface LoadingPageProps {
    backGroundColor?: string;
}

const LoadingPage = (props: LoadingPageProps): React.ReactElement => {
    const { backGroundColor } = props;

    const spinner = Styles.spinner;

    return (
        <div style={
            {
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: backGroundColor ?? 'transparent',
            }
        }
        >
            <div style={{
                padding: '50px',
            }}
            >
                <CircularProgress className={spinner} size={70} />
            </div>
        </div>
    );
};

export default LoadingPage;
